import React from "react";
import LineChart from "../../../components/LineChart/LineChart";
import { formatLocale } from 'd3';

const LevensVerwachting = () => {
	const margin = { top: 60, right: 30, bottom: 90, left: 45 };

  const localeFormatter = formatLocale({
    "decimal": ",",
    "thousands": ".",
    "grouping": [3],
    "comma": true,
  });

	const formatY = (val) => localeFormatter.format(',.0f')(val);
	const formatValueTooltip = value => formatY(value) + " mensen";

	const data = [
		{
			name: "honderdjarigen",
			values: [
				{ x: 1965, y: 200 },
				{ x: 1966, y: 177 },
				{ x: 1967, y: 191 },
				{ x: 1968, y: 187 },
				{ x: 1969, y: 202 },
				{ x: 1970, y: 282 },
				{ x: 1971, y: 225 },
				{ x: 1972, y: 363 },
				{ x: 1973, y: 356 },
				{ x: 1974, y: 404 },
				{ x: 1975, y: 427 },
				{ x: 1976, y: 440 },
				{ x: 1977, y: 460 },
				{ x: 1978, y: 575 },
				{ x: 1979, y: 658 },
				{ x: 1980, y: 1089 },
				{ x: 1981, y: 815 },
				{ x: 1982, y: 871 },
				{ x: 1983, y: 781 },
				{ x: 1984, y: 893 },
				{ x: 1985, y: 1022 },
				{ x: 1986, y: 1136 },
				{ x: 1987, y: 1230 },
				{ x: 1988, y: 1434 },
				{ x: 1989, y: 1559 },
				{ x: 1990, y: 1416 },
				{ x: 1991, y: 1530 },
				{ x: 1992, y: 1593 },
				{ x: 1993, y: 1684 },
				{ x: 1994, y: 1659 },
				{ x: 1995, y: 1691 },
				{ x: 1996, y: 1699 },
				{ x: 1997, y: 1762 },
				{ x: 1998, y: 1802 },
				{ x: 1999, y: 1847 },
				{ x: 2000, y: 1841 },
				{ x: 2001, y: 1943 },
				{ x: 2002, y: 2045 },
				{ x: 2003, y: 2147 },
				{ x: 2004, y: 2224 },
				{ x: 2005, y: 2278 },
				{ x: 2006, y: 2330 },
				{ x: 2007, y: 2381 },
				{ x: 2008, y: 2620 },
				{ x: 2009, y: 2802 },
				{ x: 2010, y: 2938 },
				{ x: 2011, y: 3023 },
				{ x: 2012, y: 3188 },
				{ x: 2013, y: 3413 },
				{ x: 2014, y: 3561 },
				{ x: 2015, y: 3560 },
				{ x: 2016, y: 3559 },
				{ x: 2017, y: 3728 }
			]
		}
	];

	return (
		<div className="vis-honderdjarigen">
			<LineChart
				margin={margin}
				colorLines={["#000"]}
				colorAxis="#333"
				labelY="aantal"
				domainY={[0, 4000]}
				data={data}
				height={600}
				formatY={formatY}
				formatValueTooltip={formatValueTooltip}
			/>

			<div className="vis-credit">
				<p>Aantal inwoners van Nederland van 99 jaar en ouder</p>
				<p>Bron: CBS Statline</p>
			</div>
		</div>
	);
};

export default LevensVerwachting;
